/*eslint-env browser*/

import $ from "jquery"
import AssetBatch from "./asset_batch.js"
import getUrlParams from "./url_params.js"

const urlParams            = getUrlParams()

const maxScreenSizePercent = 0.9
const fadeOutDuration      = 500
const containerSelector    = "#welcome"
const imageSelector        = "#welcome img"

let imagesHeight           = {}
let imagesMaxWidth         = 0
let imagesMaxHeight        = 0


let launchCallback = () => {}

let $container


function toxicodeWelcome (newLaunchCallback, {images: imagesData, onLoaded = () => {}} = {}) {
    launchCallback = newLaunchCallback

    $container = $(containerSelector)

    if (!checkHtml() || ("directToLevel" in urlParams)) {
        $container.remove()
        onLoaded()
        launchCallback()
        return
    }

    let imagesDataByUrl = {}

    imagesData.forEach(img => {
        imagesDataByUrl[img.url] = img
    })

    function onComplete (...loadedImages) {
        initImagesData(imagesDataByUrl, loadedImages)
        setOnResize()
        setClickCallback()
        setKeyCallback()
        onLoaded()
    }

    let imageUrls = Object.keys(imagesDataByUrl)

    AssetBatch.load(imageUrls, {onComplete})

}


function checkHtml () {
    if ($container.length === 0) {
        console.error('toxicodeWelcome -> Missing div with "welcome" id')
        return false
    }

    return true
}



function setOnResize () {
    setImagesHeight()
    $(window).on("resize", setImagesHeight)
}


function initImagesData (imagesDataByUrl, loadedImages) {
    imagesMaxHeight = 0
    imagesMaxWidth  = 0

    loadedImages.forEach(img => {
        let src = img.getAttribute("src")

        let $img = $(img)
        let {id, alt, outOfFlux} = imagesDataByUrl[src]
        if (id) {
            $img.attr("id", id)
        }

        if (alt) {
            $img.attr("alt", alt)
        }

        $container.append($img)
        imagesHeight[src] = img.height

        if (!outOfFlux) {
            imagesMaxHeight += img.height
            imagesMaxWidth   = Math.max(imagesMaxWidth, img.width)
        }

    })
}


function setImagesHeight () {
    let screenHeight      = $(window).height()
    let screenWidth       = $(window).width()
    let widthScale        = Math.min(1, screenWidth  * maxScreenSizePercent / imagesMaxWidth)
    let heightScale       = Math.min(1, screenHeight * maxScreenSizePercent / imagesMaxHeight)
    let scale             = Math.min(widthScale, heightScale)
    let totalImagesHeight = imagesMaxHeight * scale

    $(imageSelector).each(function () {
        setImgHeight($(this), totalImagesHeight)
    })

    centerImagesVertically(totalImagesHeight)
}


function centerImagesVertically (totalImagesHeight) {
    let screenHeight = $(window).height()
    let padding      = (screenHeight - totalImagesHeight) / 2

    $container.css({
        paddingTop: padding
    })
}


function setImgHeight ($img, totalImagesHeight) {
    const src         = $img.attr("src")
    const imageHeight = imagesHeight[src]
    const height      = imageHeight / imagesMaxHeight * totalImagesHeight

    $img.css({
        height:  `${height}px`,
        display: "block"
    })
}




function removeAndLaunch () {
    if (isMobileSafari()) {
        $container.remove()
    } else {
        $container.fadeOut(fadeOutDuration, () => $container.remove())
    }

    $(document).off("keydown", removeAndLaunch)
    $(window).off("resize", setImagesHeight)

    launchCallback()
}




function setClickCallback () {
    $container.one("click", removeAndLaunch)
}



function setKeyCallback () {
    $(document).on("keydown", removeAndLaunch)
}


function isMobileSafari () {
    return navigator.userAgent.match(/(iPod|iPhone|iPad)/) &&
           navigator.userAgent.match(/AppleWebKit/) &&
           !navigator.userAgent.match("CriOS")
}


export default toxicodeWelcome
